  (function () {
    var CS = document.currentScript, root = CS.previousElementSibling.previousElementSibling;
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var slides = root.querySelector('[data-cx-slides]');
    var thumbs = root.querySelectorAll('[data-cx-th]');
    var idxEl = root.querySelector('[data-cx-idx]');
    var n = slides ? slides.children.length : 0;
    function cur() { return slides ? Math.round(slides.scrollLeft / slides.clientWidth) : 0; }
    function go(i) { if (!slides) return; i = (i + n) % n; slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' }); }
    if (slides) {
      slides.addEventListener('scroll', function () {
        var i = cur();
        if (idxEl) idxEl.textContent = i + 1;
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.cxTh); }); });
      root.querySelectorAll('[data-cx-go]').forEach(function (b) { b.addEventListener('click', function () { go(cur() + +b.dataset.cxGo); }); });
    }

    /* Cantidad */
    var qty = root.querySelector('input[name="quantity"]');
    root.querySelectorAll('[data-cx-q]').forEach(function (b) {
      b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + +b.dataset.cxQ); });
    });

    /* Variantes */
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-cx-variants]').textContent); } catch (e) {}
    var opts = root.querySelectorAll('[data-cx-opt]');
    if (opts.length) {
      var addBtn = root.querySelector('[data-cx-addbtn]');
      var addLabel = CS.getAttribute('data-add'), outLabel = CS.getAttribute('data-out');
      var update = function () {
        var sel = [];
        root.querySelectorAll('.cx-pdp__opt').forEach(function (fs, i) {
          var c = fs.querySelector('select') || fs.querySelector('input:checked'); sel[i] = c ? c.value : null;
          var lab = root.querySelector('[data-cx-optval="' + i + '"]'); if (lab && c) lab.textContent = c.value;
        });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) { addBtn.disabled = true; addBtn.querySelector('[data-cx-addlabel]').textContent = 'Elige otra combinación'; return; }
        root.querySelector('[data-cx-vid]').value = v.id;
        root.querySelector('[data-cx-price]').textContent = v.price;
        var cmp = root.querySelector('[data-cx-compare]'); cmp.hidden = !v.compare; if (v.compare) cmp.textContent = v.compare;
        var sale = root.querySelector('[data-cx-sale]'); if (sale) { sale.hidden = !v.sale; sale.textContent = '-' + v.sale + '%'; }
        var sku = root.querySelector('[data-cx-sku]'); if (sku) { sku.hidden = !v.sku; sku.querySelector('span').textContent = v.sku || ''; }
        var outBox = root.querySelector('[data-cx-out]'), buyBox = root.querySelector('[data-cx-buy]'); if (outBox && buyBox) { outBox.hidden = v.available; buyBox.hidden = !v.available; } addBtn.disabled = !v.available; addBtn.querySelector('[data-cx-addlabel]').textContent = v.available ? addLabel : outLabel; addBtn.querySelector('[data-cx-addprice]').textContent = v.price;
        if (v.media && slides) {
          var k = Array.prototype.findIndex.call(slides.children, function (s) { return s.dataset.mediaId == v.media; });
          if (k > -1) go(k);
        }
        var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
        root.dispatchEvent(new CustomEvent('cx:variant', { detail: v }));
      };
      /* Opciones en cascada: cada opción solo muestra los valores que existen con lo ya elegido */
      var fsets = root.querySelectorAll('.cx-pdp__opt');
      var getSel = function () { var s = []; fsets.forEach(function (fs, i) { var c = fs.querySelector('select') || fs.querySelector('input:checked'); s[i] = c ? c.value : null; }); return s; };
      var cascade = function (from) {
        if (fsets.length < 2) return;
        var sel = getSel();
        for (var i = from + 1; i < fsets.length; i++) {
          var ok = [];
          variants.forEach(function (x) { for (var k = 0; k < i; k++) { if (x.options[k] !== sel[k]) return; } if (ok.indexOf(x.options[i]) < 0) ok.push(x.options[i]); });
          var fs = fsets[i], s = fs.querySelector('select');
          if (s) {
            Array.prototype.forEach.call(s.options, function (o) { var on = ok.indexOf(o.value) > -1; o.disabled = !on; o.hidden = !on; });
            if (ok.indexOf(s.value) < 0 && ok.length) s.value = ok[0];
          } else {
            var first = null, chk = null;
            fs.querySelectorAll('input').forEach(function (inp) { var on = ok.indexOf(inp.value) > -1; inp.disabled = !on; var l = inp.closest('label'); if (l) l.style.display = on ? '' : 'none'; if (on && !first) first = inp; if (inp.checked) chk = inp; });
            if ((!chk || chk.disabled) && first) first.checked = true;
          }
          sel = getSel();
        }
      };
      opts.forEach(function (o) { o.addEventListener('change', function () { cascade(+o.getAttribute('data-cx-opt')); update(); }); });
      cascade(0); update();
    }

    /* Color HEL */
    var hel = root.querySelector('[data-cx-hel]');
    if (hel) {
      var helApply = function (move) {
        var c = hel.querySelector('input:checked'); if (!c) return;
        var col = c.value;
        hel.querySelector('[data-cx-helval]').textContent = col;
        root.querySelector('[data-cx-helprop]').value = col;
        root.querySelector('[data-cx-helsku]').value = c.dataset.sku || '';
        var d = hel.querySelector('[data-cx-heldisp]');
        if (d) { var t = c.dataset.disp || ''; d.textContent = t; d.hidden = !t; d.classList.toggle('is-wait', !/^en stock/i.test(t)); }
        var sku = root.querySelector('[data-cx-sku]'); if (sku && c.dataset.sku) { sku.hidden = false; sku.querySelector('span').textContent = c.dataset.sku; }
        var any = false;
        thumbs.forEach(function (t) { var tc = t.dataset.cxColor; if (tc) { var on = tc === col; t.classList.toggle('is-hidden', !on); if (on) any = true; } });
        if (!any) thumbs.forEach(function (t) { t.classList.remove('is-hidden'); });
        if (move && slides) {
          var k = Array.prototype.findIndex.call(slides.children, function (s) { return s.dataset.cxColor === col; });
          if (k > -1) go(k);
        }
      };
      var helMap = {}; try { var hm = root.querySelector('[data-cx-heldispmap]'); if (hm) helMap = JSON.parse(hm.textContent) || {}; } catch (e) {}
      var helKit = function (base) {
        if (!base) return;
        var ds = helMap[base];
        hel.querySelectorAll('input[name="cx-hel"]').forEach(function (inp, k) {
          var m = (inp.dataset.sku || '').match(/-[A-Z]+$/);
          if (m) inp.dataset.sku = base + m[0];
          if (ds && ds[k]) inp.dataset.disp = ds[k];
        });
      };
      helKit(hel.dataset.base);
      root.addEventListener('cx:variant', function (e) { if (e.detail && e.detail.sku) { helKit(e.detail.sku); helApply(false); } });
      hel.querySelectorAll('input[name="cx-hel"]').forEach(function (i) { i.addEventListener('change', function () { helApply(true); }); });
      helApply(false);
    }

    /* Compatibilidad */
    var check = root.querySelector('[data-cx-check]');
    if (check) {
      var data = {}; try { data = JSON.parse(root.querySelector('[data-cx-compat]').textContent); } catch (e) {}
      var low = function (a) { return (a || []).map(function (x) { return String(x).toLowerCase(); }); };
      var marcas = low(data.marcas), modelos = low(data.modelos), gens = low(data.gens);
      var known = ['bmw','nissan','toyota','honda','mazda','mitsubishi','subaru','audi','volkswagen','vw','seat','skoda','mercedes','ford','opel','peugeot','renault','citroen','porsche','lexus','hyundai','kia','alfa','fiat','mini','volvo','infiniti','acura','suzuki','chevrolet','dodge','tesla','cupra','dacia','jaguar','land','lotus','abarth','smart'];
      var fit = root.querySelector('[data-cx-fit]');
      var input = check.querySelector('input');
      var recBox = root.querySelector('[data-cx-rec]');
      var esc = function (t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };
      var money = function (v) { try { return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(+v); } catch (e) { return v + ' €'; } };
      var recommend = function (q, toks) {
        var keys = toks.filter(function (t) { return known.indexOf(t) < 0 && t.length > 1 && !/^(19|20)\d\d$/.test(t); });
        var brands = toks.filter(function (t) { return known.indexOf(t) > -1; });
        var need = keys.length ? keys : brands;
        if (!need.length) return;
        var tries = [data.kind + ' ' + data.vendor + ' ' + q, data.vendor + ' ' + q, data.kind + ' ' + q];
        var i = 0, stamp = Date.now(); recBox.dataset.stamp = stamp;
        (function next() {
          if (i >= tries.length || recBox.dataset.stamp != stamp) return;
          var t = tries[i++];
          fetch((data.root || '/').replace(/\/$/, '') + '/search/suggest.json?q=' + encodeURIComponent(t) + '&resources[type]=product&resources[limit]=10')
            .then(function (r) { return r.json(); })
            .then(function (j) {
              if (recBox.dataset.stamp != stamp) return;
              var ps = (((j || {}).resources || {}).results || {}).products || [];
              ps = ps.filter(function (p) { var tl = (p.title || '').toLowerCase(); return p.handle !== data.handle && need.every(function (k) { return tl.indexOf(k) > -1; }); });
              if (!ps.length) return next();
              recBox.innerHTML = '<p class="cx-pdp__rec-h">Para tu ' + esc(q) + ' tenemos:</p>' + ps.slice(0, 3).map(function (p) {
                var img = p.image ? p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
                return '<a class="cx-pdp__rec-i" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span></span>') + '<b>' + esc(p.title) + '</b><em>' + money(p.price) + '</em></a>';
              }).join('');
              recBox.hidden = false;
            }).catch(function () {});
        })();
      };
      var run = function (q) {
        q = q.trim(); if (!q) { fit.hidden = true; return; }
        var ql = q.toLowerCase(), toks = ql.split(/[\s,\/\-]+/).filter(Boolean);
        var brandSaid = known.some(function (b) { return toks.indexOf(b) > -1; });
        var brandOk = !brandSaid || marcas.some(function (m) { return ql.indexOf(m) > -1 || (m === 'volkswagen' && toks.indexOf('vw') > -1); });
        var parts = []; modelos.forEach(function (m) { m.split(/[\s\/]+/).forEach(function (p) { if (p.length > 1) parts.push(p); }); });
        var genOk = gens.some(function (g) { return toks.indexOf(g) > -1 || (g.length > 2 && ql.indexOf(g) > -1); });
        var modelOk = parts.some(function (p) { return toks.indexOf(p) > -1; });
        var rest = toks.filter(function (t) { return known.indexOf(t) < 0 && marcas.indexOf(t) < 0 && parts.indexOf(t) < 0 && !/^(19|20)\d\d$/.test(t); });
        var ok = brandOk && (genOk || (modelOk && !gens.length) || (!gens.length && !modelos.length && brandSaid));
        var maybe = !ok && brandOk && modelOk && gens.length && !rest.length;
        fit.hidden = false;
        fit.className = 'cx-pdp__fit ' + (ok ? 'is-ok' : maybe ? 'is-maybe' : 'is-no');
        fit.innerHTML = maybe ? 'Solo vale para estas generaciones: <strong>' + (data.gens || []).join(', ') + '</strong>. Escribe también la de tu coche (p. ej. ' + q.replace(/</g, '') + ' ' + (data.gens || [''])[0] + ').' : ok ? '✓ Encaja en tu ' + q.replace(/</g, '') : 'No lo tenemos registrado como compatible con «' + q.replace(/</g, '') + '». ' + (data.wa ? '<a href="' + data.wa + '" target="_blank" rel="noopener">Pregúntanos por WhatsApp</a> antes de comprar.' : '');
        recBox.hidden = true; recBox.innerHTML = ''; recBox.dataset.stamp = '0';
        if (!ok && !maybe) recommend(q, toks);
        try { localStorage.setItem('cx-car', q); } catch (e) {}
      };
      check.addEventListener('submit', function () { run(input.value); });
      try { var saved = localStorage.getItem('cx-car'); if (saved) { input.value = saved; run(saved); } } catch (e) {}
    }

    root.querySelectorAll('[data-cx-tab-open]').forEach(function (a) {
      a.addEventListener('click', function () { document.dispatchEvent(new CustomEvent('cx:tab', { detail: a.dataset.cxTabOpen })); });
    });
  })();
